import { graphql, navigate } from "gatsby"
import React, { Fragment } from "react"
import { Helmet } from "react-helmet"
import rehypeReact from "rehype-react"
import styled from "styled-components"
import Navbar from "../components/Navbar/Navbar"
import LoginStateContext, {
  LoginStateContextProvider,
} from "../contexes/LoginStateContext"
import PagesContext from "../contexes/PagesContext"
import getNamedPartials from "../partials"
import CourseProgress from "../partials/CourseProgress"
import { getCachedUserDetails, loggedIn } from "../services/moocfi"
import Layout from "./Layout"
import "./remark.css"

const ContentWrapper = styled.div`
  padding-bottom: 2rem;

  p {
    margin-bottom: 2rem;
  }
`

export default class CoursePartOverviewTemplate extends React.Component {
  static contextType = LoginStateContext

  async componentDidMount() {
    if (!loggedIn()) {
      return
    }

    let userInfo = await getCachedUserDetails()
    const submitted = userInfo?.extra_fields?.submitted
    if (submitted === undefined) {
      navigate("/missing-info")
    }
  }

  render() {
    const { data } = this.props
    const { frontmatter, htmlAst } = data.page
    const allPages = data.allPages.edges.map((o) => {
      const res = o.node?.frontmatter
      res.exercises = o.node?.moocfiExercises
      return res
    })
    const partials = getNamedPartials()
    const renderAst = new rehypeReact({
      createElement: React.createElement,
      components: partials,
    }).Compiler

    const filePath = data.page.fileAbsolutePath.substring(
      data.page.fileAbsolutePath.lastIndexOf("/data/"),
      data.page.fileAbsolutePath.length,
    )

    return (
      <PagesContext.Provider
        value={{
          all: allPages,
          current: { frontmatter: frontmatter, filePath: filePath },
        }}
      >
        <Helmet title={frontmatter.title} />
        <LoginStateContextProvider>
          <Layout>
            <Fragment>
              <Navbar> </Navbar>
              <ContentWrapper>{renderAst(htmlAst)}</ContentWrapper>
            </Fragment>
            <CourseProgress></CourseProgress>
          </Layout>
        </LoginStateContextProvider>
      </PagesContext.Provider>
    )
  }
}

export const pageQuery = graphql`
  query ($path: String!) {
    page: markdownRemark(frontmatter: { path: { eq: $path } }) {
      htmlAst
      html
      frontmatter {
        path
        title
        topic
      }
      fileAbsolutePath
    }
    allPages: allMarkdownRemark {
      edges {
        node {
          id
          frontmatter {
            path
            title
            topic
          }
          moocfiExercises {
            id
            type
            parentPagePath
          }
        }
      }
    }
  }
`
